import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useRef } from 'react';
import { SplunkLogger } from './splunk-logger';
const SplunkContext = createContext(null);
function isConfigValid(config) {
    return Boolean(config.endpoint && config.token);
}
export const SplunkProvider = ({ config, children }) => {
    const loggerRef = useRef(null);
    const configValid = isConfigValid(config);
    if (loggerRef.current === null && configValid) {
        loggerRef.current = new SplunkLogger(config);
    }
    if (!configValid && process.env.NODE_ENV !== 'production') {
        console.warn('[SplunkProvider] Splunk config is missing endpoint or token. Logging is disabled.');
    }
    const logger = loggerRef.current;
    useEffect(() => {
        if (!logger)
            return;
        const handleBeforeUnload = () => {
            logger._hecClient.flushSync();
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            logger.flush().then(() => {
                logger.destroy();
            });
        };
    }, [logger]);
    return _jsx(SplunkContext.Provider, Object.assign({ value: logger }, { children: children }));
};
export function useSplunkLogger() {
    const logger = useContext(SplunkContext);
    if (logger === null) {
        return noopLogger;
    }
    return logger;
}
/** A no-op logger that silently discards all log calls when Splunk is not configured. */
const noopLogger = {
    debug: () => { },
    info: () => { },
    warn: () => { },
    error: () => { },
    flush: () => Promise.resolve(),
    setDefaultMetadata: () => { },
    destroy: () => { },
    _hecClient: { flushSync: () => { }, flush: () => Promise.resolve(), destroy: () => { }, enqueue: () => { } },
};
